import React, { useState } from 'react';
import { Box, Divider } from '@chakra-ui/react';
import IntroSection from '../../../../components/Profile/intro-section/intro-section.component.jsx';
import { IgnoredArticlesTableComponent } from './IgnoredArticles/index.jsx';
import { IgnoredWritersTableComponent } from './IgnoredWriters/index.jsx';

const HISTORY_TAB = [
  {
    name: 'Ignored Articles',
    value: 'articles'
  },
  {
    name: 'Ignored Writers',
    value: 'writers'
  }
];
const IgnoredContent = () => {
  const [selectedTab, setSelectedTab] = useState('articles');

  return (
    <Box>
      <IntroSection
        title="Ignored Content"
        description="Review articles and writers you have ignored"
        titleSize="text-2xl"
        desSize="text-base"
      />
      <Divider my="1.25rem" color="anti-flash-white" />
      <div>
        <div className="flex mb-4 overflow-x-auto no-scrollbar w-full sticky top-0 z-10 bg-[#FAFAFA]">
          {HISTORY_TAB.map((item, index) => (
            <div
              className="flex flex-col items-center gap-2 cursor-pointer w-[50%] md:w-[200px]"
              key={index}
              onClick={() => setSelectedTab(item.value)}
            >
              <p
                className={`text-sm whitespace-nowrap ${selectedTab === item.value ? 'text-[#333333] font-[800]' : 'text-[#808080] font-[600]'} pt-3 text-center`}
              >
                {item.name}
              </p>
              <div
                className={`h-[4px] w-full ${selectedTab === item.value ? 'bg-[#4CAF50]' : 'bg-[#E6E7EB]'} rounded-[10px]`}
              ></div>
            </div>
          ))}
        </div>
        {selectedTab === 'articles' && <IgnoredArticlesTableComponent tab={selectedTab} />}
        {selectedTab === 'writers' && <IgnoredWritersTableComponent tab={selectedTab} />}
      </div>
    </Box>
  );
};

export default IgnoredContent;
